import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { cn } from '../../../lib/utils';

export interface TaskyLightboxProps {
  open: boolean;
  onClose: () => void;
  src?: string;
  alt?: string;
  children?: React.ReactNode;
  className?: string;
}

export const TaskyLightbox: React.FC<TaskyLightboxProps> = ({
  open,
  onClose,
  src,
  alt = '',
  children,
  className,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className={cn('relative max-w-[90vw] max-h-[90vh]', className)}>
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute -top-10 right-0 text-white/80 hover:text-white"
        >
          <X className="w-7 h-7" />
        </button>
        {children ?? (src && <img src={src} alt={alt} className="rounded-tasky-md max-h-[90vh] object-contain" />)}
      </div>
    </div>,
    document.body,
  );
};
